import styled from 'styled-components';
import { CommonDetails } from '../common-styles.styles';

export const Details = styled(CommonDetails)`
  line-height: 1.5;
  /* h1{color:#000000;} */
  strong {
    color: #000000;
  }
  a {
    color: #166bd3;
    cursor: pointer;
    outline: none;
    text-decoration: none;
  }
  a:hover {
    color: #f77521;
  }
`;
